import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';

const FreestarAd = ({ automationId, channel, className, placementName }) => {
    const [loadAd, setLoadAd] = useState(false);
    const eventHandler = () => {
        setLoadAd(true);
    };

    useEffect(() => {
        document?.addEventListener('pageReadyForAdLoad', eventHandler);

        return () => {
            document?.removeEventListener('pageReadyForAdLoad', eventHandler);
        };
    }, []);

    const publisher = 'jcpenney-com';
    const adChannel = channel || undefined; // this is only required for category and department pages

    return loadAd ? (
        <div data-automation-id={automationId} className={className}>
            <FreestarAdSlot
                publisher={publisher}
                placementName={placementName}
                channel={adChannel}
            />
        </div>
    ) : null;
};

FreestarAd.defaultProps = {
    automationId: '',
    channel: '',
    className: '',
};

FreestarAd.propTypes = {
    placementName: string.isRequired,
    automationId: string,
    channel: string,
    className: string,
};

export default FreestarAd;
